import "../index.css";
import CustomForm from "../components/NewsletterSubscribe";
import Footer from "../components/Footer";
import {
  FaSpotify,
  FaMoon,
  FaSun,
  FaYoutube,
  FaInstagram,
} from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";

import { useState } from "react";

function MusicBio() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isHidden, setIsHidden] = useState(true);

  let theme = "";
  let hidden = "hidden ";

  if (isDarkMode) {
    theme = "theme-dark ";
  }

  // If not hidden, make hidden on click
  if (!isHidden) {
    hidden = "";
  }

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const toggleHidden = () => {
    setIsHidden(!isHidden);
  };

  return (
    <div className={theme}>
      {/* Navbar */}
      <nav className="bg-skin-fill relative w-full translate-y-1 justify-around space-x-2 pt-5 text-center md:items-center lg:justify-around">
        {/* Signature, links back to home page */}
        <div className="flex items-center justify-evenly p-8 lg:justify-around xl:left-10">
          <a href="/" className="text-center uppercase">
            <span className="heading text-skin-base hover:text-skin-accent text-3xl sm:text-4xl ">
              Johnny Goodman
            </span>
          </a>
          {/* Toggle theme switch */}
          <div
            className="absolute left-3 top-3 lg:static"
            onChange={toggleTheme}
          >
            <input type="checkbox" className="checkbox" id="checkbox" />
            <label for="checkbox" className="label">
              <FaSun className="text-skin-inverted mr-2 text-[12px]"></FaSun>
              <FaMoon className="text-skin-inverted text-[10px]"></FaMoon>
              <div className="ball"></div>
            </label>
          </div>

          {/* Secondary nav */}
          <div
            className={`text-skin-base hidden items-center justify-center space-x-3 text-center text-lg lg:flex`}
          >
            <a href="/" className="hover:text-skin-accent px-3 py-4">
              Home
            </a>
            <a href="/bio" className="hover:text-skin-accent px-3 py-4">
              Bio
            </a>
            <a
              href="/"
              target="blank"
              className="hover:text-skin-accent px-3 py-4"
            >
              Tour
            </a>

            <a
              href="/"
              target="blank"
              className="hover:text-skin-accent px-3 py-4"
            >
              Store
            </a>
          </div>
        </div>

        {/* Mobile nav button */}
        <div className="text-skin-base absolute top-2 right-3 lg:hidden">
          <GiHamburgerMenu
            className="text-2xl"
            onClick={toggleHidden}
          ></GiHamburgerMenu>
        </div>

        {/* Mobile Nav */}
        <div
          className={`${hidden} mobile-menu bg-skin-fill pb-10`}
          id="mobile-nav"
        >
          <div className="mt-4 flex flex-col justify-start space-y-7 text-center text-xl">
            <a
              href="/"
              className="text-skin-base hover:text-skin-accent hover:text-blue-500"
            >
              Home
            </a>
            <a
              href="/bio"
              className="text-skin-base hover:text-skin-accent hover:text-blue-500"
            >
              Bio
            </a>
            <a
              href="/"
              target="blank"
              className="text-skin-base hover:text-skin-accent hover:text-blue-500"
            >
              Tour
            </a>

            <a
              href="/"
              target="blank"
              className="text-skin-base hover:text-skin-accent pb-2 hover:text-blue-500"
            >
              Store
            </a>
          </div>
        </div>
      </nav>

      {/* Listen to Johnny */}
      <section class="parrilex flex h-64 flex-col items-center justify-center space-y-10 bg-cover  bg-fixed bg-center p-8 text-center md:p-10 lg:h-[600px] lg:p-36"></section>

      {/* Bio */}
      <div className="bg-skin-fill flex w-screen flex-col items-center justify-center p-5 md:p-20">
        <div className="max-w-[1100px]">
          <p className="text-md text-skin-base leading-8 lg:text-lg">
            <strong>Johhny's</strong> music allows the paint to break to make it
            beautiful. Look around, look at what we have. Beauty is everywhere,
            you only have to look to see it. The only thing worse than yellow
            snow is green snow. Nothing's gonna make your husband or wife madder
            than coming home and having a snow-covered dinner. If you've been in
            Alaska less than a year you're a Cheechako. Isn't it fantastic that
            you can change your mind and create all these happy things?
          </p>
          <a href="/" className="">
            <div className="btn-sm bg-skin-primary my-10 w-fit uppercase">
              See more of Johnny
            </div>
          </a>
        </div>
      </div>

      <Footer></Footer>
    </div>
  );
}
export default MusicBio;
